<template>
    <v-form
        ref="formPartDialog"
        v-model="form.valid"
        lazy-validation
    >
        <v-dialog v-model="dialogState" persistent max-width="740px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ $t('common.add') }}
                    <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                    </span>
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('contracts.form.partDialog.title') }}</span>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-row>
                        <v-col :md="form.visibility.part.md" v-if="form.visibility.part.show">
                            <input-auto-complete :setup.sync="form.selects.part"></input-auto-complete>
                        </v-col>

                        <v-col :md="form.visibility.typePart.md" v-if="form.visibility.typePart.show">
                            <v-text-field
                                ref="type"
                                v-model="setup.part.item.type"
                                :label="$t('contracts.form.partDialog.type.label')"
                                :rules="form.rules.type"
                                required
                                dense
                                filled
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-text-field
                                ref="name"
                                v-model="setup.part.item.name"
                                :label="$t('contracts.form.partDialog.name.label')"
                                :rules="form.rules.name"
                                dense
                                filled
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="close()">{{ $t('common.close') }}</v-btn>
                    <v-btn color="primary" @click="save()">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import InputAutoComplete from '@/components/InputAutoComplete'

export default {
    name: 'contract-part-dialog',
    components: {
        InputAutoComplete
    },
    props: ['show', 'setup', 'contract'],
    data () {
        return {
            dialogState: false,
            form: {
                valid: false,
                rules: {
                    type: [
                        v => !!v || this.$t('contracts.form.partDialog.type.required'),
                        v => (v && v.length >= 3) || this.$t('contracts.form.partDialog.type.length')
                    ],
                    name: [
                        v => !!v || this.$t('contracts.form.partDialog.name.required'),
                        v => (v && v.length >= 3) || this.$t('contracts.form.partDialog.name.length')
                    ]
                },
                selects: {
                    part: {
                        label: this.$t('contracts.form.partDialog.part.label'),
                        text: 'name',
                        value: 'value',
                        icon: 'description',
                        multiple: false,
                        clearable: true,
                        filled: true,
                        items: [],
                        selectedItems: [],
                        other: false
                    }
                },
                visibility: {
                    part: {
                        show: true,
                        md: 12
                    },
                    typePart: {
                        show: false,
                        md: 6
                    }
                }
            }
        }
    },
    watch: {
        show: function (val, oldVal) {
            this.init()
            this.dialogState = val
        },
        dialogState: function (val, oldVal) {
            this.$emit('update:show', val)
        },
        'form.selects.part.selectedItems': {
            handler: function (val) {
                this.setup.part.item.type = ''
                if (this.setup.companyType !== 'department') {
                    if (val === 'Outro') {
                        this.form.visibility.part.md = 6
                        this.form.visibility.typePart = {
                            show: true,
                            md: 6
                        }
                    } else {
                        this.form.visibility.part.md = 12
                        this.form.visibility.typePart.show = false
                    }
                } else {
                    if (val === 'Outro') {
                        this.form.visibility.part.md = 6
                        this.form.visibility.typePart = {
                            show: true,
                            md: 6
                        }
                    } else {
                        this.form.visibility.part.md = 12
                        this.form.visibility.typePart.show = false
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        init () {
            this.form.selects.part.items = this.setup.selects.part.items
            this.$refs.formPartDialog.reset()
        },
        save () {
            if (!this.$refs.formPartDialog.validate()) {
                return
            }
            window.getApp.refreshContracts = true
            if (this.form.selects.part.selectedItems.length > 0 && this.form.selects.part.selectedItems !== 'Outro') {
                this.setup.part.item.type = this.form.selects.part.selectedItems
            }
            if (this.setup.part.item.type && this.setup.part.item.name) {
                let isMainPart = (this.contract.part.length <= 0)
                this.contract.part.push({
                    type: this.setup.part.item.type,
                    name: this.setup.part.item.name,
                    isMainPart: isMainPart
                })
                this.setup.part.item.type = undefined
                this.setup.part.item.name = undefined
            }
            this.close()
        },
        close () {
            this.$emit('close-part-dialog')
            this.dialogState = false
        }
    }
}
</script>
